module.exports = __webpack_public_path__ + "img/niño81.b29d3508.jpg";